import { useState, useMemo } from 'react'
import {
	EuiButton,
	EuiPopoverTitle,
	EuiPopover,
} from '@equipmentshare/ds2'
import AllocatedTable from '../AllocatedTable'

import { Reservation as GqlReservation, FulfillmentOrder } from '../../../../../graphql'

export type Reservation = Pick<GqlReservation, 'reservationId' | 'quantity' | 'targetType' | 'targetId'> & {
	fulfillmentOrder?: Pick<FulfillmentOrder, 'id' | 'orderNumber'> | null,
}

export type AllocatedPopoverProps = {
	reservations: Reservation[],
}

export default function AllocatedPopover( { reservations }: AllocatedPopoverProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const quantity = useMemo( () => reservations.reduce( ( total, reservation ) => total + reservation.quantity, 0 ), [ reservations ] )

	if ( quantity === 0 ) {
		return null
	}

	const button = (
		<EuiButton
			color="text"
			onClick={() => setIsPopoverOpen( !isPopoverOpen )}
			size="s"
		>
			{quantity} {quantity === 1 ? 'item' : 'items'}
		</EuiButton>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={() => setIsPopoverOpen( false )}
		>
			<EuiPopoverTitle>Allocated</EuiPopoverTitle>
			<AllocatedTable reservations={reservations} />
		</EuiPopover>
	)
}
